export const SUPPORTED_LANGUAGES = ['ko', 'en', 'ja', 'zh-CN', 'zh-TW', 'th'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  th: 'ไทย',
};

export const COUNTRY_TO_LANGUAGE: Record<string, SupportedLanguage> = {
  KR: 'ko',
  US: 'en',
  JP: 'ja',
  CN: 'zh-CN',
  TW: 'zh-TW',
  SG: 'en',
  PH: 'en',
  TH: 'th',
};

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
  return !!value && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

// URL 쿼리스트링의 lang 파라미터를 읽어 지원 언어면 반환, 아니면 null
// (예: ?lang=en → 'en') 매장 설정 언어보다 우선 적용하기 위한 값
export function getLanguageOverrideFromSearch(search: string): SupportedLanguage | null {
  const lang = new URLSearchParams(search).get('lang');
  return isSupportedLanguage(lang) ? lang : null;
}
